export default {
  cbConfiguration: {
    default: 'Configuration de la carte bancaire',
    card_amex_number: 'Numéro de carte',
    card_amex_holder: 'Porteur de carte',
    card_amex_expiry: "Date d'expiration de la carte",
    card_amex_crypto: 'Cryptogramme visuel'
  }
}
